var _rect, _rect2, _rect3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.63925,
    y: 1.2309,
    width: 36.5695,
    height: 23.9754,
    rx: 3,
    transform: "rotate(15.5029 7.63925 1.2309)",
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4305,
    y: 14.3407,
    width: 36.5695,
    height: 23.9754,
    rx: 3,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4305,
    y: 21.4237,
    width: 36.5695,
    height: 2.7228,
    fill: "#413D45",
    stroke: "#413D45",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9156,
    cy: 31.444,
    r: 2.3614,
    fill: "#6CA5D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9801,
    cy: 31.444,
    r: 2.3614,
    fill: "#6FA489"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPaymentMethod);
export default __webpack_public_path__ + "static/media/credit-card-payment-method.f88924cbb788a774fe11bc7d8d17e595.svg";
export { ForwardRef as ReactComponent };